import styles from './uploadPaymentOrderReceiptModal.module.css'
import { Form, FormField, ModalId, useUIActions, FieldType, FileField, FileType, Spinner, Modal, useUIState, Validatable } from "../../../../../features/ui"
import { PaymentOrder } from '../../../state/types'
import { useEffect, useState } from "react"
import { useActions } from "./actions"
import { fileHelpers } from '../../../../../features/files'
import { toList } from "../../../../../utils/listUtils"
import { operationHelpers } from '../../../../operations'

type Props = {
    paymentOrder?: PaymentOrder
}

export const UploadPaymentOrderReceiptModal = (props: Props) => {
    const { paymentOrder } = props
    
    const [key, setKey] = useState(0)
    const [receiptFile, setReceiptFile] = useState<File>()
    const [receiptValidation, setReceiptValidation] = useState<string>()

    const { openedModal } = useUIState()

    const { paymentReceiptFileName } = fileHelpers
    const { describeCode } = operationHelpers

    const { submitReceipt } = useActions()
    const { closeModal } = useUIActions()

    useEffect(() => setKey(key + 1), [openedModal])

    if (!paymentOrder) return <Spinner />

    const onChangeFile = (value?: File) => {
        setReceiptValidation(undefined)
        setReceiptFile(value)
    }

    const fields: FormField[] = [
        {
            name: 'code',
            type: FieldType.NUMBER,
            label: 'Orden de Pago',
            render: () => <>{describeCode(paymentOrder)}</>
        },
        {
            name: 'receiptUrl',
            type: FieldType.FILE,
            label: 'Comprobante de Pago',
            hint: 'Formato: PDF, JPG, PNG',
            render: () => (
                <Validatable validations={toList(receiptValidation)} left className={styles.receiptValidation}>
                    <FileField
                        id="receiptUrl"
                        fileName={paymentReceiptFileName(paymentOrder.code)}
                        fileTypes={[FileType.PDF, FileType.JPEG, FileType.PNG]}
                        onChange={onChangeFile}
                    />
                </Validatable>
            )
        }
    ]
    
    const validate = (): boolean => {
        if (!receiptFile) {
            setReceiptValidation('Debe subir el comprobante')
            return false
        }
    
        return true
    }

    const onSubmit = () => {
        if (validate()) {
            submitReceipt(paymentOrder.id, receiptFile!)
            setReceiptValidation(undefined)
        }
    }

    const handleCancel = () => {
        closeModal(ModalId.UPLOAD_PAYMENT_ORDER_RECEIPT)
        setReceiptValidation(undefined)
    }

    return (
        <Modal
            modalId={ModalId.UPLOAD_PAYMENT_ORDER_RECEIPT}
            title="Subir Comprobante de Pago"
            widthSize="m"
            actions={[]}
        >
            <Form
                key={key}
                formId="upload-payment-order-receipt-form"
                fields={fields}
                createMode={false}
                updateLabel="Confirmar"
                onSubmit={onSubmit}
                onCancel={handleCancel}
            />
        </Modal>
    )
}
